import type { Retailer } from "@faire/web-api/indigofair/settings/Serialized";
import { createSettingsContextProvider } from "@faire/web/common/settings/hooks/createSettingsContextProvider";

export const { useSetting, useAssignSetting, SettingsContextProvider } =
  createSettingsContextProvider<Retailer>();
